import React, { useState } from 'react';
import OutletHead from '../../../../components/common/outlet-head';
import AssociateForm from '../../../../components/associates/forms';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { IoArrowBackOutline, IoSettingsOutline } from 'react-icons/io5';
import { v4 as uuidv4 } from 'uuid';
import { doc, setDoc } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { db, storage } from '../../../../firebase';

function AddAssociate() {

  let navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [imageSource, setImageSource] = useState('');
  const [associateData, setAssociateData] = useState({
    name: '',
    fatherHusband: '',
    gender: '',
    dob: '',
    panNumber: '',
    aadharNumber: '',
    phoneNumber: '',
    alternatePhoneNumber: '',
    email: '',
    address: '',
    city: '',
    pincode: '',
    state: '',
    photo: '',
    bankDetails: []
  });
  const [inputError, setInputError] = useState(null);

  const fireData = async (id, data) => {
    data = { addedOn: new Date(), updatedOn: new Date(), ...data };
    try {
      await setDoc(doc(db, "Associates", id), data);
      setIsLoading(false);
      navigate(-1);
    } catch (error) {
      console.log('Adding Associate Data [Error] : ', error);
      setIsLoading(false);
    }
  }

  const fireDataWithPhoto = async (id, data, imageObj) => {
    const storageRef = ref(storage, `/Associates/${id}`);

    const uploadTask = uploadBytesResumable(storageRef, imageObj);

    uploadTask.on("state_changed", (snapshot) => {
      const percent = Math.round(
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      );
      console.log(percent);

    }, (err) => console.log('Associate Photo Uploading [Error] :', err),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          var tempData = { ...data }
          tempData.photo = url;
          fireData(id, tempData);
        });
      }
    );
  }

  function validateAndPostData() {
    const { name, fatherHusband, gender, dob, aadharNumber, phoneNumber, address, city, pincode, state } = associateData;
    if (!name) {
      setInputError({ ...inputError, name: 'This field is required.' });
    } else if (!fatherHusband) {
      setInputError({ ...inputError, fatherHusband: 'This field is required.' });
    } else if (!gender) {
      setInputError({ ...inputError, gender: 'This field is required.' });
    } else if (!dob) {
      setInputError({ ...inputError, dob: 'This field is required.' });
    } else if (!aadharNumber) {
      setInputError({ ...inputError, aadharNumber: 'This field is required.' });
    } else if (!phoneNumber) {
      setInputError({ ...inputError, phoneNumber: 'This field is required.' });
    } else if (!address) {
      setInputError({ ...inputError, address: 'This field is required.' });
    } else if (!pincode) {
      setInputError({ ...inputError, pincode: 'This field is required.' });
    } else if (!city) {
      setInputError({ ...inputError, city: 'This field is required.' });
    } else if (!state) {
      setInputError({ ...inputError, state: 'This field is required.' });
    } else {
      let uuid = uuidv4();
      setIsLoading(true);
      if (imageSource) {
        fireDataWithPhoto(uuid, associateData, imageSource);
      } else {
        fireData(uuid, associateData);
      }
    }
  }

  return (
    <section className='section'>
      <OutletHead
        left={
          <div className='d-flex align-items-center'>
            <Button
              variant='light'
              size='sm'
              className='p-2 me-3 rounded-circle'
              onClick={() => navigate(-1)}
            >
              <IoArrowBackOutline size={24} />
            </Button>
            <h5 className='mb-0'>Add Associate</h5>
          </div>
        }
        right={
          <div className='d-flex align-items-center'>
            <Button
              variant="light"
              className='border py-2 px-4 me-3'
            >
              <IoSettingsOutline size={20} />
              <span className='ps-2'>Settings</span>
            </Button>
            <Button
              variant="primary"
              className='py-2 px-5'
              onClick={validateAndPostData}
            >
              Save
            </Button>
          </div>
        }
      />
      <div className='px-3 border-top'>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='mb-5 position-relative'>
              {
                isLoading ?
                  <div className='loader'>
                    <div className='spinner' />
                  </div>
                  :
                  null
              }
              <AssociateForm
                data={associateData}
                setData={setAssociateData}
                imageSource={imageSource}
                setImageSource={setImageSource}
                inputError={inputError}
                setInputError={setInputError}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AddAssociate;
